export var PeriodUnit;
(function (PeriodUnit) {
    /** Not defined. */
    PeriodUnit["UNDEFINED"] = "UNDEFINED";
    /** Time unit is a day. */
    PeriodUnit["DAY"] = "DAY";
    /** Time unit is a week. */
    PeriodUnit["WEEK"] = "WEEK";
    /** Time unit is a month. */
    PeriodUnit["MONTH"] = "MONTH";
    /** Time unit is a year. */
    PeriodUnit["YEAR"] = "YEAR";
})(PeriodUnit || (PeriodUnit = {}));
export var AppliedAt;
(function (AppliedAt) {
    AppliedAt["UNKNOWN_CHARGE_EVENT"] = "UNKNOWN_CHARGE_EVENT";
    /** Will charge the fee on the first payment. If the order has a free trial, it will charge after the free trial. */
    AppliedAt["FIRST_PAYMENT"] = "FIRST_PAYMENT";
})(AppliedAt || (AppliedAt = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var ArchivedFilter;
(function (ArchivedFilter) {
    /** Returns all plans that are active. */
    ArchivedFilter["ACTIVE"] = "ACTIVE";
    /** Returns all plans that are archived. */
    ArchivedFilter["ARCHIVED"] = "ARCHIVED";
    /** Returns all plans that are active and archived. */
    ArchivedFilter["ARCHIVED_AND_ACTIVE"] = "ARCHIVED_AND_ACTIVE";
})(ArchivedFilter || (ArchivedFilter = {}));
export var PublicFilter;
(function (PublicFilter) {
    /** Returns all public and hidden plans. */
    PublicFilter["PUBLIC_AND_HIDDEN"] = "PUBLIC_AND_HIDDEN";
    /** Returns only public plans. */
    PublicFilter["PUBLIC"] = "PUBLIC";
    /** Returns only hidden plans. */
    PublicFilter["HIDDEN"] = "HIDDEN";
})(PublicFilter || (PublicFilter = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map